import React, {useEffect, useState} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PodiumPosOne, PodiumPosSecond, PodiumPosThird } from '../svgs';
import { useIntl } from 'react-intl';
import QuizControls from './quiz-controls';
import { EslidesEvent, Presentation } from '../../types/presentation';
import getEncodedImageUrl from '../../helpers/get-encoded-image';
import {gql, useSubscription} from "@apollo/client";
import {leaderboard} from "../../gql/quiz-gql";
import FinalQuizControls from "./final-quiz-controls";
import { useLocation } from "react-router-dom";

// quiz live podium page
const QuizFinalPodium: React.FC<{ locale: string; setLocale: any; presentation: Presentation; event: EslidesEvent;}> = ({ locale, setLocale, presentation,event }) => {

  let users = [];
  const answeredUsers = 10;
  const intl = useIntl();
  const location = useLocation();
  // 25/09/2026 Diljith Krishna Reason: Opened from Manage Quiz for a non-live quiz; hide live-session controls.
  const isNonLiveView = new URLSearchParams(location.search).get("view") === "non-live";
  // @ts-ignore
  const [connectedUserCount, setConnectedUserCount] = useState(parseInt(localStorage.getItem('connected_users')));
  // @ts-ignore
  const [answeredUserCount, setAnsweredUserCount] = useState(parseInt(localStorage.getItem('answered_users')));


 // getting final leader board from backend
  const {data, loading} = useSubscription<{
    leaderboard: Array<{
      user: {
        id: string;
        photo: string;
        name: string;
      }
      points: number;
    }>
  }>(leaderboard, {
    variables: {
      presentation_id: presentation._id,
    }
  })

  console.log('leaderboard',data);


  return (
    <div className="quiz-live-screen-container podium-container final-podium-container">
      <div className="podium-main" style={{height:'100vh'}}>
        <div className="quiz-home-header d-none d-md-block p-t-2">
          <Container fluid>
            <Row className="align-items-center"  style={{paddingLeft:'10px'}}>
              <Col className="text-md-left text-center" style={{paddingLeft:'20px',paddingTop:'20px'}}>
              {event?.logo ?
                          <img
                              height={100}
                              src={getEncodedImageUrl(event.logo, 110, 110, "contain")}
                              alt="logo"
                          /> : <img src="/images/logo-default.png" alt="logh" />
                      }    </Col>
              <Col className="text-md-right text-center" style={{paddingTop:'20px'}}><div style={{width:200,position:'relative',float:'right',paddingRight:'20px'}}><h6>{presentation.name} </h6></div></Col>
            </Row>
          </Container>
        </div>
        <Container fluid>
          <Row>
            <Col>
              <div className="podium-results-container ">
                  <h5 className="text-center">PODIUM</h5>
                    <p className="text-center">{intl.formatMessage({id: 'quiz.the.winners.are'})}</p>

                  <div className="d-block d-md-none">
                    <div className="your-position">
                      <span>{intl.formatMessage({id: 'sidebar.you.are.the'})} <strong>18<sup>th</sup></strong>,</span>
                      <span className="points">{intl.formatMessage({id: 'with'})} <strong>220 {intl.formatMessage({id: 'points'})}</strong></span>
                    </div>
                  </div>

                {
                  data?.leaderboard.length !== 0 && <>
                      <div className="d-block d-md-none">
                        <div className="mobile-stage-container">
                          { data?.leaderboard && data?.leaderboard.length>1 &&    <div className="score-details first">
                            <span className="stand"></span>
                            <span className="score">
                       {data?.leaderboard[1].user.name.length >20 ? data?.leaderboard[1].user.name.split(' ')[0] :data?.leaderboard[1].user.name}<span>+{data?.leaderboard[1].points}</span>
                        </span>
                          </div> }
                          {data?.leaderboard && data?.leaderboard.length>0 &&   <div className="score-details second">
                            <span className="stand"></span>
                            <span className="score">
                       {data?.leaderboard[0].user.name.length >20 ? data?.leaderboard[0].user.name.split(' ')[0] :data?.leaderboard[0].user.name}<span>+{data?.leaderboard[0].points}</span>
                        </span>
                          </div>}
                          {data?.leaderboard && data?.leaderboard.length>2 &&  <div className="score-details third">
                            <span className="stand"></span>
                            <span className="score">
                      {data?.leaderboard[2].user.name.length >20 ? data?.leaderboard[2].user.name.split(' ')[0] :data?.leaderboard[2].user.name}<span>+{data?.leaderboard[2].points}</span>
                        </span>
                          </div>}
                        </div>
                      </div>

                      <div className="stage m-t-20 d-none d-md-flex ">
                        <div className="stage-components">
                          {data?.leaderboard && data?.leaderboard.length>1 &&  <div className="pos second">
                            <div className="score-container">
                          <span className="score">

                           {data?.leaderboard[1].user.name.length >20 ? data?.leaderboard[1].user.name.split(' ')[0] :data?.leaderboard[1].user.name}<span>+{data?.leaderboard[1].points}</span>
                          </span>
                              <PodiumPosSecond />
                            </div>
                            <span className="stand"></span>
                          </div>}
                          {data?.leaderboard && data?.leaderboard.length>0 &&   <div className="pos first">
                            <div className="score-container">
                              <PodiumPosOne />
                              <span className="score">
                           {data?.leaderboard[0].user.name.length >20 ? data?.leaderboard[0].user.name.split(' ')[0] :data?.leaderboard[0].user.name}<span>+{data?.leaderboard[0].points}</span>
                          </span>
                            </div>
                            <span className="stand"></span>
                          </div>}
                          {data?.leaderboard && data?.leaderboard.length>2 && <div className="pos third">
                            <div className="score-container">
                              <PodiumPosThird />
                              <span className="score">

                        {data?.leaderboard[2].user.name.length >20 ? data?.leaderboard[2].user.name.split(' ')[0] :data?.leaderboard[2].user.name}<span>+{data?.leaderboard[2].points}</span>
                        </span>
                            </div>
                            <span className="stand"></span>
                          </div>}
                        </div>
                      </div>

                    </>
                }



              </div>
                <Row>
                  <Col className="mx-auto" md={10}>
                    <div className="remaining-results ">
                      <ul>
                        {
                          data?.leaderboard.slice(3,30).map((leader, index) => {

                            return  <li key={index}><span>{index + 1}/{leader.user.name}<span>+{leader.points}</span></span></li>
                          })
                          }
                      </ul>
                    </div>
                  </Col>
                </Row>
            </Col>
          </Row>
        </Container>
      </div>
      {/* 25/09/2026 Diljith Krishna Reason: Hide live-session controls when opened from Manage Quiz for a non-live quiz. */}
      {!isNonLiveView && (
        <FinalQuizControls answerId="asd" presentationId={presentation._id} usersLength={connectedUserCount} podium={false} answersLength={answeredUserCount} onBack={true} noNext={true}  />
      )}

    </div>
  )
}

export default QuizFinalPodium;
